import { render, staticRenderFns } from "./status-tracker.vue?vue&type=template&id=053fff4c&scoped=true&"
import script from "./status-tracker.vue?vue&type=script&lang=js&"
export * from "./status-tracker.vue?vue&type=script&lang=js&"
import style0 from "./status-tracker.vue?vue&type=style&index=0&id=053fff4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053fff4c",
  null
  
)

export default component.exports